import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@/components/ui/button';
import { isArabic } from '@/config/constants';
import { cn } from '@/lib/utils';
export const Options = ({ options, handleOptionClick, disabled }) => {
    if (disabled) {
        return null;
    }
    return (_jsx("span", { className: "animate-fade-in clear-both mt-3 ml-auto flex list-none flex-wrap justify-end p-0 opacity-0 delay-500 [animation-fill-mode:forwards]", children: options === null || options === void 0 ? void 0 : options.map(({ label, text }) => (_jsx(Button, { variant: "outline-neutral", size: "sm", onClick: () => handleOptionClick(text, label), className: cn('m-2 mt-0 mr-2 inline-block h-fit cursor-pointer text-left whitespace-normal', {
                'text-center': (label === null || label === void 0 ? void 0 : label.length) && label.length < 8,
            }), disabled: disabled, dir: isArabic(label), children: label }, label))) }));
};
